<bas-breadcrumb></bas-breadcrumb>
@if (overrideAdv) {
	<h1 bas-headline>{{ 'adv.generate.headline.override' | msgKeyCached }}</h1>
} @else {
	<h1 bas-headline>{{ 'adv.generate.headline.new' | msgKeyCached }}</h1>
}
<form [formGroup]="advForm"
      buiValidationContext="adv.generate">
	<bui-group>
		<bui-field>
			<bui-label required>{{ 'adv.generate.legalName.label' | msgKeyCached }}</bui-label>
			<input pInputText
			       buiValidationControl
			       formControlName="legalName"
			       class="col-6/12">
		</bui-field>
		<bui-field>
			<bui-label required>{{ 'adv.generate.streetAndNumber.label' | msgKeyCached }}</bui-label>
			<input pInputText
			       buiValidationControl
			       formControlName="streetAndNumber"
			       class="col-6/12">
		</bui-field>
		<bui-field>
			<bui-label required>{{ 'adv.generate.zipAndCity.label' | msgKeyCached }}</bui-label>
			<input pInputText
			       buiValidationControl
			       formControlName="zip"
			       class="col-1/12">
			<input pInputText
			       buiValidationControl
			       formControlName="city"
			       class="col-5/12">
		</bui-field>
		<bui-field>
			<bui-label required>{{ 'adv.generate.representedBy.label' | msgKeyCached }}</bui-label>
			<input pInputText
			       buiValidationControl
			       formControlName="representedBy"
			       class="col-6/12">
		</bui-field>

		@if (overrideAdv) {
			<bui-field>
				<bui-label required>{{ 'adv.generate.comment.label' | msgKeyCached }}</bui-label>
				<textarea pTextarea
				          buiValidationControl
				          class="col-6/12"
				          formControlName="comment"
				          rows="5">
				</textarea>
			</bui-field>
			<bui-field>
				<p-checkbox binary
				            buiValidationControl
				            formControlName="confirmOverrideAdv"
				            inputId="confirmOverrideAdv"></p-checkbox>
				<label for="confirmOverrideAdv">{{ 'adv.generate.confirmOverrideAdv.label' | msgKey }}</label>
			</bui-field>
		}
	</bui-group>
</form>

<bas-required-hint></bas-required-hint>

<bui-button-line>
	<p-button (onClick)="back()">{{ 'button.cancel.alt' | msgKey }}</p-button>
	<p-button severity="primary"
	          (onClick)="save()">{{ (overrideAdv ? 'button.update.alt' : 'button.generate') | msgKey }}
	</p-button>
</bui-button-line>

